module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/data-table/data-table.component.scss
// module id = ./src/app/shared/components/data-table/data-table.component.scss
// module chunks = main